<template>
  <div>
		<date-range-picker
			ref="picker"
			:locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
			:singleDatePicker="false"
			:autoApply="true"
			v-model="state.dateRange"
			:append-to-body="true"
			opens="left"
	  >
		<template v-slot:input style="min-width: 350px;">
				<div class="date-range-value">
					{{ moment(state.dateRange.startDate ).format('LL') }} - {{ moment(state.dateRange.endDate ).format('LL') }} 
				</div>
				<span>
						<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M24 6.85742H8.00001C6.73764 6.85742 5.71429 7.88077 5.71429 9.14314V25.1431C5.71429 26.4055 6.73764 27.4288 8.00001 27.4288H24C25.2624 27.4288 26.2857 26.4055 26.2857 25.1431V9.14314C26.2857 7.88077 25.2624 6.85742 24 6.85742Z" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M20.5714 4.57129V9.14272" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M11.4286 4.57129V9.14272" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M5.71429 13.7139H26.2857" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</span>
		</template>
	</date-range-picker> 
	</div>

</template>
<script>
import { reactive, watch } from '@vue/composition-api'
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'DateRangePickers',
		components: { DateRangePicker },
		props: {
			onDateSelected: Function,
			defaultDateRange: Object,
			getInitialDateSet: Function
		},
    setup(props) {
			const state = reactive({
					dateRange: props.defaultDateRange || {
						startDate: moment().subtract(12, 'months'),
						endDate: moment()
					},
			});

			watch(() => state.dateRange, ({ endDate,startDate }) =>  {
				// call onDateSelected function if a date range has been picked from the date picker
				props.onDateSelected({
					endDate,
					startDate
				})
			})

			return {
					state,
					moment,
			}
    }
}
</script>
<style lang="scss">
.daterangepicker {
	display: flex;

	.calendars {
		display: flex;
  }
}

.date-range-value {
	margin-right: 20px;
}

.form-control {
	box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.48), 0px 0px 4px rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		height: 20px;
	}
}   


</style>